import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalUserType } from '../../types';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import PendingApprovalButtonI18nTitleRequester from './PendingApprovalButtonI18nTitleRequester';
import PendingApprovalButtonI18nTitleApprover from './PendingApprovalButtonI18nTitleApprover';
import PendingApprovalButtonI18nTitleApproversList from './PendingApprovalButtonI18nTitleApproversList';
import PendingApprovalButtonI18nTitleNonParticipant from './PendingApprovalButtonI18nTitleNonParticipant';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function PendingApprovalButtonI18nTitle() {
  const approval = useApprovalContext();
  const {
    currentUserType,
    approvalType,
    approvalAction
  } = approval.meta;
  switch (currentUserType) {
    case ApprovalUserType.REQUESTER:
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(View, {
            marginBlockEnd: "100",
            as: "div",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.PendingApprovalTooltipTitle.approversList"
            }), /*#__PURE__*/_jsx(PendingApprovalButtonI18nTitleApproversList, {
              approval: approval
            })]
          }), /*#__PURE__*/_jsx(PendingApprovalButtonI18nTitleRequester, {
            approvalType: approvalType,
            approvalAction: approvalAction
          })]
        });
      }
    case ApprovalUserType.APPROVER:
      {
        return /*#__PURE__*/_jsx(PendingApprovalButtonI18nTitleApprover, {
          approvalType: approvalType,
          approvalAction: approvalAction
        });
      }
    case ApprovalUserType.NON_PARTICIPANT:
      {
        return /*#__PURE__*/_jsx(PendingApprovalButtonI18nTitleNonParticipant, {
          approvalType: approvalType,
          approvalAction: approvalAction
        });
      }
    default:
      throw new UnreachableI18nCaseError(currentUserType);
  }
}
export default PendingApprovalButtonI18nTitle;